import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const DifferenceValue = ({ value, isMinus = false }) => {
  const valueText = useMemo(() => {
    if (value === 0) {
      return value;
    }

    return `${isMinus ? '-' : '+'}${value}`;
  }, [isMinus, value]);

  const containerClassNames = useMemo(
    () =>
      classnames('member-center__difference_value', {
        add: !isMinus && value > 0,
        minus: isMinus && value > 0,
      }),
    [isMinus, value],
  );

  return <span className={containerClassNames}>{valueText}</span>;
};

DifferenceValue.propTypes = {
  value: PropTypes.number.isRequired,
  isMinus: PropTypes.bool,
};

DifferenceValue.displayName = 'DifferenceValue';

export default DifferenceValue;
